import meters from './meters';
import service from './service';
import settings from './settings';
import workflow from './workflow';

const data = {
  ...meters,
  ...service,
  ...settings,
  ...workflow
};

export default data;



// WEBPACK FOOTER //
// ./src/screens/data/flow2/index.js